import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { Button } from "@jugl-web/ui-kit";
import { ReactComponent as BgGradient } from "./assets/background-gradient.svg";
import { ReactComponent as BgGradientAlt } from "./assets/background-gradient-alt.svg";
import { ReactComponent as ArrowRightIcon } from "./assets/arrow-right.svg";

export const UpgradeToProCard: React.FC<{
  nextPlanName: string;
  description?: string;
  buttonLabel?: string;
  variant?: "default" | "alt";
  onClick?: () => void;
}> = ({
  nextPlanName,
  description,
  buttonLabel,
  variant = "default",
  onClick,
}) => {
  const { t } = useTranslations();
  const Gradient = variant === "alt" ? BgGradientAlt : BgGradient;
  return (
    <div className="bg-dark relative h-[234px] overflow-hidden rounded-3xl p-8">
      <div className="absolute top-0 left-0 h-full w-full">
        <Gradient className="h-full w-full" />
      </div>
      <div className="relative flex h-full flex-col">
        <h3 className="font-secondary my-0 text-3xl font-semibold text-white">
          {description
            ? nextPlanName
            : t(
                {
                  id: "cx-plans-page.upgrade-card-title",
                  defaultMessage: "Upgrade to {planName}",
                },
                { planName: nextPlanName }
              )}
        </h3>
        <p className="font-secondary text-dark-200 my-1 text-sm">
          {description ??
            t(
              {
                id: "cx-plans-page.upgrade-card-description",
                defaultMessage:
                  "Unlock deeper insights and higher AI Credits by upgrading to {planName}",
              },
              { planName: nextPlanName }
            )}
        </p>

        <div className="mt-auto">
          <Button
            variant="secondary"
            iconEnd={<ArrowRightIcon />}
            onClick={onClick}
          >
            {buttonLabel ??
              t({
                id: "cx-plans-page.upgrade",
                defaultMessage: "Upgrade",
              })}
          </Button>
        </div>
      </div>
    </div>
  );
};
